import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { LinearProgress } from '@material-ui/core';

import { setCurrentFolder } from '../redux/folderDbSlice';
import { setCurrentBook } from '../redux/bookDbSlice';
import { setDefaultSheet } from '../redux/sheetDbSlice';
import useWorkBackend from '../hooks/useWorkBackend';
import useCurrentUserDb from '../hooks/useCurrentUserDb';
import useUserCondition from '../hooks/useUserCondition';

type RedirectorProps = {
  doneRedirect: () => void;
}
const Redirector: React.FC<RedirectorProps> = ({ doneRedirect }) => {
  const dispatch = useDispatch();
  const { authUser, latest } = useWorkBackend();
  const [userId] = useCurrentUserDb();
  const [, condition] = useUserCondition(userId);

  useEffect(() => {
    if (!userId || !condition || !latest) return;
    dispatch(setCurrentFolder(condition.folderId || null));
    dispatch(setCurrentBook(condition.bookId || null));
    dispatch(setDefaultSheet(condition.sheetId || null));
    doneRedirect();
  }, [userId, condition, authUser, latest])

  if (!authUser || !condition || !latest) return <LinearProgress />;
  else if ((condition.where === 'book' || condition.where === 'sheet') && condition.bookId) return <Redirect to="/book" />;
  else return <Redirect to="/" />;
}

export default Redirector;
